import { render, staticRenderFns } from "./NeuraBlogs.vue?vue&type=template&id=66663524"
import script from "./NeuraBlogs.vue?vue&type=script&lang=js"
export * from "./NeuraBlogs.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/neura-blogs.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports